// extracted by mini-css-extract-plugin
export default {"imagetextbox":"imagetextbox__qTX+X","container":"container__ZZYDp","textbox":"textbox__AJGUG","imgcon":"imgcon__PCMo8","lefttext":"lefttext__d0JVP","reversed":"reversed__2Nb3A"};